import { SecureCodes } from '@gower/shared-sdk/src/lib/Core/SecureCodes';
import { expose } from '@gower/react-ui/store';
import { SidedCrudBase } from '../../temp/SidedCrud';

class SecureCodesStore extends SidedCrudBase( SecureCodes, null, { viewName: 'SEC-CODE' } )
{

}

export const { useStore, provider } = expose( SecureCodesStore );